import Login from '@hogwarts/ui-components-login';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authenticationService, {
  MFA_LOCKED_ERROR_CODE,
} from '../../services/authentication';

const LoginContainer = ({ loading }) => {
  const navigate = useNavigate();
  const [loginState, setLoginState] = useState(
    authenticationService.requiresSSO()
      ? 'SSO'
      : authenticationService.requiresMfa()
      ? 'MFA'
      : 'LOG-IN'
  );
  const [error, setError] = useState(null);
  const [lastCredentials, setLastCredentials] = useState(null);

  return (
    <Login
      state={loading ? 'LOADING' : loginState}
      error={error}
      lastCredentials={lastCredentials}
      onLogin={async (credentials) => {
        setLoginState('LOGGING-IN');
        setError(null);
        setLastCredentials(credentials);
        const loginError = await authenticationService.login(credentials);
        if (loginError) {
          setError(loginError);
          setLoginState('LOG-IN');
        }
      }}
      onResetPasswordRequest={() => {
        setLoginState('PASSWORD-RESET-REQUEST');
        setError(null);
      }}
      onResetPasswordRequestSubmitted={async (email) => {
        setError(null);
        const resetSuccess = await authenticationService.resetPasswordRequest(
          email
        );
        if (!resetSuccess) {
          setError('Unable to reset password.');
        }
      }}
      onResetPasswordRequestComplete={() => {
        setLoginState('LOG-IN');
        setError(null);
      }}
      onVerifyToken={async (token) => {
        setLoginState('LOGGING-IN');
        try {
          const result = await authenticationService.verifyMfaToken(token);
          if (result.ok) {
            navigate(0);
          } else if (result.code === MFA_LOCKED_ERROR_CODE) {
            setError(MFA_LOCKED_ERROR_CODE);
            setLoginState('LOG-IN');
          } else {
            setError('INVALID-TOKEN');
            setLoginState('MFA');
          }
        } catch (error) {
          setError('ERROR');
          setLoginState('MFA');
        }
      }}
      onLogout={() => {
        authenticationService.logout();
      }}
    ></Login>
  );
};

export default LoginContainer;
